import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=d5e52916&"
import script from "./Space.vue?vue&type=script&lang=js&"
export * from "./Space.vue?vue&type=script&lang=js&"
import style0 from "./Space.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports